import { createContext } from "react"

import { Entry } from "shared/types/Entry"

export interface ColorInputContextType {
  colors: Entry<string>[]
}

export const ColorInputContext = createContext<ColorInputContextType>({
  colors: []
})
